// Public-surface configuration. The DrStack marketing site is a static single page — the demo form
// submits via a `mailto:` link, so there is no API client and no auth here. The only cross-app URL
// is the patient-portal "Sign in" link, supplied via env (VITE_PATIENT_ORIGIN) so it stays portable
// across environments. Falls back to the local patient dev port when unset.
const PATIENT_ORIGIN = (import.meta.env.VITE_PATIENT_ORIGIN as string | undefined) ?? "";

const DEV_PATIENT_FALLBACK = "http://localhost:5174";

/** Absolute base origin of the patient portal (no trailing slash). */
export function patientOrigin(): string {
  const origin = PATIENT_ORIGIN.trim() || DEV_PATIENT_FALLBACK;
  return origin.replace(/\/+$/, "");
}

/** Absolute URL of the patient-portal sign-in screen. */
export function patientSignInUrl(): string {
  return new URL("/sign-in", patientOrigin()).toString();
}

/** Contact address used across the site (CTA, demo-form mailto, footer). */
export const CONTACT_EMAIL = "hello@drstack.ai";
